import type { FC } from "react"
import { Divider, Stack, Text } from "@chakra-ui/react"

import { useMe } from "user/providers/MeProvider"
import CardContainer from "common/components/CardContainer"
import AddressInfo from "common/components/AddressInfo"
import type { Account } from "query/graphql"
import { useOrganization } from "organization/providers/OrganizationProvider"

const SummaryTitle: FC<{
  title: string
}> = ({ title }) => {
  const me = useMe()
  const { organization } = useOrganization()

  if (!me) return null

  return (
    <CardContainer isTableView pb={1} width={{ base: "100%", sm: "750px" }}>
      <Stack
        align="center"
        as="section"
        mb={0}
        mt={{ base: 0, lg: 2 }}
        p={{ base: 3, lg: 0 }}
        spacing={{ base: 1, sm: 0 }}
        w="full"
      >
        <Stack
          direction={{ base: "column", lg: "row" }}
          pt={{ base: 0, sm: 1 }}
          px={{ base: 1, sm: 4 }}
          spacing={{ base: 1, lg: 6 }}
          width="100%"
        >
          {title ? (
            <Text
              as="h3"
              fontWeight="bold"
              py={2}
              textStyle="h3"
              wordBreak="break-word"
            >
              {title}
            </Text>
          ) : (
            <Text as="h3" color="gray.500" fontWeight="bold" textStyle="h3">
              Untitled
            </Text>
          )}
        </Stack>
        <Divider py={{ base: 1, sm: 1 }} />
        {organization ? (
          <Stack
            align={{ base: "start", lg: "center" }}
            direction={{ base: "column", lg: "row" }}
            pt={{ base: 0, sm: 1 }}
            px={{ base: 1, sm: 4 }}
            spacing={{ base: 1, sm: 3 }}
            width="100%"
          >
            <AddressInfo
              account={me as Account}
              label="by"
              slug={organization.slug}
            />
          </Stack>
        ) : null}
      </Stack>
    </CardContainer>
  )
}

export default SummaryTitle
